import React from "react"

import { Container } from "./styles"

const GenericProductDescription = ({ headline, subheadline, description, dataId }) => (
  <Container data-exp-id={dataId}>
    <h2 dangerouslySetInnerHTML={{ __html: headline }} />
    {subheadline && <h4 dangerouslySetInnerHTML={{ __html: subheadline }} />}
    {description && <div dangerouslySetInnerHTML={{ __html: description }} />}
  </Container>
)

export default GenericProductDescription
